import { TRACK_WIDTH_LIMITS, type TrackAppearance } from '../../../renderer/src/track-appearance';
import { ROUTE_LINE_STYLES, type RouteLineStyleId } from '../domain/route-line-style';
import './track-appearance.css';
import { useEffect, useState } from 'react';
import { CompactRangeControl } from './CompactRangeControl';

interface Properties {
  appearance: TrackAppearance;
  lineStyle: RouteLineStyleId;
  onChange: (appearance: TrackAppearance) => void;
  onLineStyleChange: (style: RouteLineStyleId) => void;
}

export function TrackAppearanceControl({ appearance, lineStyle, onChange, onLineStyleChange }: Properties) {
  const [hex, setHex] = useState(appearance.color);
  useEffect(() => setHex(appearance.color), [appearance.color]);
  const validHex = /^#[0-9a-f]{6}$/i.test(hex);
  return <fieldset className="track-appearance">
    <legend>Track appearance</legend>
    <label className="tool-control"><span>Line style</span>
      <select value={lineStyle} onChange={event => onLineStyleChange(event.target.value as RouteLineStyleId)}>
        {ROUTE_LINE_STYLES.map(style => <option key={style.id} value={style.id}>{style.label}</option>)}
      </select>
    </label>
    <div className="tool-control track-color" role="group" aria-label="Trace color"><span>Color</span>
      <div><input type="color" aria-label="Track color" value={appearance.color}
        onChange={event => onChange({ ...appearance, color: event.target.value })} />
        <input type="text" aria-label="Track color hex" className="track-color-hex" value={hex}
          maxLength={7} spellCheck={false} aria-invalid={!validHex}
          onChange={event => {
            const value = event.target.value;
            setHex(value);
            if (/^#[0-9a-f]{6}$/i.test(value)) onChange({ ...appearance, color: value.toLowerCase() });
          }} onBlur={() => setHex(appearance.color)} /></div>
    </div>
    <CompactRangeControl label="Track width" value={appearance.width} min={TRACK_WIDTH_LIMITS.min} max={TRACK_WIDTH_LIMITS.max}
      onChange={width => onChange({ ...appearance, width })} />
  </fieldset>;
}
